// PrivateRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import verifyUser from './verifyUser';

const PrivateRoute = () => {
  return verifyUser() ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
